import { collection, query, onSnapshot, doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

const STUDENT_REPORTS_COLLECTION = 'studentReports';

export const studentReportService = {
  subscribeToReports(schoolId, callback) {
    const q = query(collection(db, STUDENT_REPORTS_COLLECTION));
    return onSnapshot(q, (snapshot) => {
      const reports = snapshot.docs
        .map(d => ({ id: d.id, ...d.data() }))
      .filter(d => {
        if (!schoolId) return true;
        const ids = (Array.isArray(schoolId) ? schoolId : [schoolId]).map(v => String(v).toLowerCase());
        return ids.includes((d.schoolId || '').toLowerCase());
      });
      callback(reports);
    }, (error) => {
      console.error('Error loading student reports:', error);
      callback([]);
    });
  },

  async resolveReport(reportId, resolvedBy, notes = '') {
    await updateDoc(doc(db, STUDENT_REPORTS_COLLECTION, reportId), {
      // iOS StudentReportStatus enum is Title-case: "Open"/"Resolved"/"Dismissed".
      // Web views compare case-insensitively ('Resolved' also satisfies them).
      status: 'Resolved',
      resolvedAt: new Date().toISOString().replace(/\.\d{3}Z$/, 'Z'),
      resolvedBy,
      resolutionNotes: notes
    });
  }
};
